import { uniqueId } from "lodash";
import { getAuthorization } from "./appConstants";
let Authorization = getAuthorization()
export const NetworkHelper = {
  get: url => {
    return new Promise((resolve, reject) => {
      fetch(url, {
        method: "GET",
        headers: {
          "Authorization": Authorization
        }
      })
        .then(res => {
          if (!res.ok) {
            throw res;
          }
          return res.json();
        })
        .then(data => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  post: (url, payload,headers={}) => {
    return new Promise((resolve, reject) => {
      fetch(url, {
        method: "POST",
        body: JSON.stringify(payload),
        headers: {
          "Content-Type": "application/json",
          "Authorization": Authorization,
          ...headers
        },
      })
        .then(res => {
          if (!res.ok) throw res;
          return res.json();
        })
        .then(data => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  put: (url, payload = {}) => {
    return new Promise((resolve, reject) => {
      fetch(url, {
        method: "PUT",
        body: JSON.stringify(payload),
        headers: {
          "Content-Type": "application/json",
          "Authorization": Authorization
        },
      })
        .then(res => {
          if (!res.ok) throw res;
          return res.json();
        })
        .then(data => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  API_STATUS: {
    NOT_STARTED: null,
    INITIALIZED: 0,
    SUCCESS: 1,
    FAILURE: -1,
  },
};
